export const LOCAL_PRODUCTS_KEY = "products";

export const CART_ACTIONS_STATUS = {
  add: "add",
  remove: "remove",
};
